export default "__VITE_ASSET__DCQac9Sf__"